import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isLoggedin } from "../../lib/isLoggedin";
import PublicHeader from "./PublicHeader";

const AUTH_PAGES = new Set([
  "/",
  "/login",
  "/signup",
  "/forgot-password",
  "/otp-verification",
  "/set-password",
]);

const PublicLayout = () => {
  const location = useLocation();
  const loggedIn = isLoggedin();

  return loggedIn && AUTH_PAGES.has(location.pathname) ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <div className="min-h-screen bg-[#f7f8fc] text-slate-950">
      <PublicHeader />
      <div className="w-full">
        <Outlet />
      </div>
    </div>
  );
};

export default PublicLayout;
